/** CreteSuite logo (v1 common/Logo). */
export const Logo = ({ width = 200 }: { width?: number }) => (
  <img src='/assets/cs-logo.svg' alt='CreteSuite' width={width} />
)
